module.exports = __webpack_public_path__ + "media/images/samples/home/ig1@2x-53c58ae3f143efb60aa67abcac2e2b83.png";